<template>
  <div
      :class="{'noMask':noMask}"
      class="mask flex align-center justify-center size24 colorBlack"
      :style="{'top':top,'left':left,'right':right,'bottom':bottom}"
  >
    <div class="empty-data">
      暂无数据展示
      <div class="button-group">
        <el-button class="btn-1" @click="jumpDemo">查看演示环境</el-button>
        <el-button :class="{'btn-2': authType == 'market', 'btn-3':  authType == 'ads'}" @click="jump">{{linkText}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: "app-mask",
  props:{
    authType :{
      type:String,
      default:'market', // market  ads
    },
    linkText :{
      type:String,
      default:'立即店铺授权',
    },
    routeTo:{
      type:String,
      default:'/system/market',
    },
    top:{
      type:String,
      default:'50px',
    },
    left:{
      type:String,
      default:'16px',
    },
    right:{
      type:String,
      default:'16px',
    },
    bottom:{
      type:String,
      default:'16px',
    }
  },
  computed:{
    ...mapGetters(['marketAuthType']),
    noMask:function (){
      let marketAuth = this.marketAuthType.find(r=> r.authType===this.authType);
      if(marketAuth){
        return marketAuth.auth
      }else {
        return true
      }
    }
  },
  methods:  {
    jump(){
      this.$router.push({
          path: this.routeTo,
        });
    },
    jumpDemo() {
      window.open(`http://mdemonew.gerpgo.cn/manager-login?isAutoLogin=1`);
    }
  }
}
</script>

<style scoped lang="scss">
.mask{
  position: absolute;
  background-color: rgba(52,90,146,0.12);
  border-radius: 2px;
  top:0;
  left: 0;
  right: 0;
  bottom: 0;
  font-weight: 600;
  z-index: 999;
}
.noMask{
  display: none;
}
.empty-data{
  text-align:center;
}
.button-group{
  margin-top:10px;
}
.btn-1{
  background: #1F6EEF;
  color:#FFFFFF;
  border-radius: 2px;
  margin: 0px 5px ;
}
.btn-2{
  background: #2DA641;
  color:#FFFFFF;
  border-radius: 2px;
}
.btn-3{
  background: #ED6A0C;
  color:#FFFFFF;
}
.btn-1:hover{
  background: #327bf1;
}
.btn-2:hover{
  background: #54aa63;
}
.btn-3:hover{
  background: #e68540;
}

</style>